import { createEntityAdapter } from "@reduxjs/toolkit";
import { Thread } from "./types";

export const emailAdapter = createEntityAdapter({
  selectId: (email: Thread) => email.id,
});
